import { gql } from "@apollo/client";

export const UPDATE_ROLE_PERMISSIONS = gql`
  mutation UpdateRolePermissions(
    $roleId: Int!
    $featureId: Int!
    $isActive: Boolean!
    $permissionId: Int
  ) {
    updateRolePermissions(
      params: {
        roleId: $roleId
        featureId: $featureId
        isActive: $isActive
        permissionId: $permissionId
      }
    ) {
      roleId
      featureId
      featureName
      featureKey
      featureDescription
      permissionId
      permissionName
      permissionKey
      isActive
    }
  }
`;
